import ApiService from '../api-service/ApiService';
import { CRM_URL } from '../../constants/UrlConstant';

const CRMService = {
  getFilteredCRMs: (page, limit, data) =>
    ApiService.putData(`${CRM_URL.GET_FILTERED_CRM_URL}?page=${page}&limit=${limit}`, data),
  getCRMGraph: () => ApiService.putData(CRM_URL.GET_CRM_GRAPH_URL),

  /**
   * Import leads from CSV file
   * @param {File} file - CSV file to upload
   * @returns {Promise} API response with import results
   */
  importCSV: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return ApiService.postData(CRM_URL.IMPORT_CSV_URL, formData);
  },

  /**
   * Download CSV template for lead imports
   * Triggers browser download of template file
   */
  downloadCSVTemplate: () => {
    ApiService.getData(CRM_URL.CSV_TEMPLATE_URL)
      .then(response => {
        // Create blob from response data
        const blob = new Blob([response.data], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);

        // Create temporary link and trigger download
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'lead_import_template.csv');
        document.body.appendChild(link);
        link.click();

        // Cleanup
        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(url);
      })
      .catch(error => {
        console.error('Failed to download CSV template:', error);
        throw error;
      });
  },

  /**
   * Create a single lead manually
   * @param {Object} leadData - Lead information
   * @returns {Promise} API response with created lead
   */
  createManualLead: (leadData) => {
    return ApiService.postData(CRM_URL.CREATE_MANUAL_LEAD_URL, leadData);
  },
};

export default CRMService;
